import { Icon } from '@studio/design-system/icon';
import type { ReactNode } from 'react';

/** Error component. */
export const Error = ({ children }: { children: ReactNode }) => (
  <div className='flex gap-4 rounded-4 bg-error p-6 text-sm text-white'>
    <Icon icon='info' />
    {children}
  </div>
);
